import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';
import { Query, QueryLoanArgs } from '../../../@types/codegen/types';
import usePublicLoanCalculation from '../../../Gql/ad/useLoanCalculation';
import LOAN_CALCULATION from '../Queries/LOAN_CALCULATION';
import useSettings from '../State/Settings/useSettings';

/**
 * Recalculates a loan. Against the public API through calculatePayment (the
 * option's identifier picks the financial option), otherwise the legacy query.
 */
const useLoanCalculation = (
  id: string,
  duration?: number,
  downPayment?: number,
  residual?: number,
  financialOptionId?: string | null
) => {
  const { publicApi } = useSettings();
  const legacy = useQuery<Query, QueryLoanArgs>(LOAN_CALCULATION, {
    variables: {
      id,
      duration: Math.round(duration as number),
      downPayment: Math.round(downPayment as number),
      residual: (residual as number) || 0,
    },
    skip: !!publicApi || duration === undefined || downPayment === undefined,
  });
  const gql = usePublicLoanCalculation(publicApi, id, {
    financialOptionId,
    duration,
    downPayment,
    residual,
  });

  // Stable object: LoanModal resets its sliders in an effect keyed on `data`.
  const gqlData = useMemo(() => (gql.loan ? ({ loan: gql.loan } as Query) : undefined), [gql.loan]);

  if (publicApi) {
    return { loading: gql.loading, data: gqlData };
  }
  return { loading: legacy.loading, data: legacy.data };
};

export default useLoanCalculation;
